// @flow
import * as React from "react";
import styled, { css, keyframes } from "styled-components";

import Facebook from "../../images/fb-icon.svg";
import Google from "../../images/gp-icon.svg";
// import Facebook2 from "../../images/fb-icon-2.svg";
// import Google2 from "../../images/gp-icon-2.svg";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  position: relative;
  display: inline-block;

  :before {
    position: absolute;
    display: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: "";
    width: 34px;
    height: 34px;
    margin-top: 4px;
    margin-left: 4px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
  }

  :after {
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    margin-top: -14px;
    margin-left: -12px;
    box-sizing: border-box;
    width: 28px;
    height: 28px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-top: 2px solid #fff;
    border-radius: 50%;
    animation: ${spin} 0.5s linear infinite;
    content: "";
  }

  ${props =>
    props.pending &&
    css`
      :before,
      :after {
        display: block;
      }
    `};
`;

const SocialButton = styled.a`
  margin: 4px;
  display: inline-block;
  vertical-align: middle;
  width: 34px;
  height: 34px;
  text-indent: 100%;
  border-radius: 4px;
  background: #9e9e9e;
  cursor: pointer;

  :disabled {
    cursor: default;
    opacity: 0.9;
  }

  :last-of-type {
    margin-right: 0;
  }

  ${props =>
    props.network === "fb" &&
    css`
      background: #4e66a9 url(${Facebook}) center no-repeat;
      background-size: 7px 14px;
    `};

  ${props =>
    props.network === "gp" &&
    css`
      background: #d54934 url(${Google}) center no-repeat;
      background-size: 18px 12px;
    `};

  ${({ theme, network }) =>
    theme.newIndex &&
    network === "fb" &&
    css`
      background: url(${Facebook}) center no-repeat;
      background-size: 11px 22px;
    `};

  ${({ theme, network }) =>
    theme.newIndex &&
    network === "gp" &&
    css`
      background: url(${Google}) center no-repeat;
      background-size: 34px 22px;
    `};
`;

type Props = {
  network: string,
  pending: boolean
};

export default function SocialLink({ network, pending, ...props }: Props) {
  return (
    <Loader pending={pending}>
      <SocialButton network={network} {...props} rel="nofollow">
        {network}
      </SocialButton>
    </Loader>
  );
}



// WEBPACK FOOTER //
// ./src/components/Auth/SocialLink.js